
import React, {useContext, useEffect, useState, useRef} from 'react';
import {Redirect, useHistory} from 'react-router-dom';

import {
    Grid,
    Divider,
    Button,
    Card, 
    CardContent,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails 
  } from '@material-ui/core';


import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import { spacing } from '@material-ui/system';
import SocketIOContext, {initializeSocket} from '../../context/SocketIOContext';
import { getSubjectFromParentEmail } from '../../common/apiGetUtilities';
import { useTranslation } from 'react-i18next'; 
import { firebaseStorage } from '../../firebaseConfig';
import { green, blue, orange, yellow, blueGrey, lightBlue } from '@material-ui/core/colors';
import {
  Activity,
  Info,
  Smile,
  Video,
  UserPlus,
  Film
} from 'react-feather';
import * as RouteNames from '../../common/routeNames';

import Actions from './components/Actions';
import { SubjectInfo } from '../../dialogs/SubjectInfoDialog';
import Stats from './components/Stats';
import useStyles from './styles';
import { useUserState } from '../../context/UserContext';
import * as AppRoutes from '../../common/routeNames';
import { useQuery, QueryClient, QueryClientProvider } from 'react-query';
import { DeviceProps, emptyDeviceState } from '../../common/entityUtilities';
import NewAssessmentDialog from '../../dialogs/NewAssessmentDialog/NewAssessmentDialog';
import { UserProps } from '../../common/entityUtilities';
import { useSubjectState } from '../../context/SubjectContext';
import { useStudy } from '../../context/StudyContext';
import StudyClaimDialog from '../../dialogs/StudyClaimDialog';
import { Alert } from '@material-ui/lab';
import { getAllAssesments, getFilteredAssesments, getSampleAssesments } from '../../common/apiGetUtilities';
import AssessmentInfoTable from '../../components/Assessments/AssessmentInfoTable';
import { deleteCloudVideo, reprocessVideo, showDialog, showAlert } from '../../common/utilities';
import { debugLog } from '../../common/debugUtilities';
import { refreshToken } from '../../context/UserContext';
import { useProcessingDispatch } from '../../context/ProcessingContext';

const currentDate = new Date();

function Dashboard(props) {

    const history = useHistory();
    const {t, i18n} = useTranslation();
    const classes = useStyles();
    const [redirect, setRedirect] = useState(null);
    const cribsyUser = useUserState();
    const subject = useSubjectState();
    const setProcessing = useProcessingDispatch();
    const [isAuthenticated, setAuthenticated] = useState(false);
    const [devices, _setDevices] = useState([]);
    const [authLevel, setAuthLevel] = useState(-1);
    const [assessments, _setAssessments] = useState([]);
    const [sampleAssessments, setSampleAssessments] = useState([]);
    const registerPage = AppRoutes.USER_SETTINGS;
    const socket = initializeSocket();
    const devicesRef = useRef(devices);
    const [expandAccordion, setExpanded] = useState(false);
    const [expandSampleAccordion, setSampleExpanded] = useState(false);
    const assessmentsRef = useRef(assessments);
    const sampleAssessmentsRef = useRef(sampleAssessments);
    const userRef = useRef(cribsyUser);
    const [subjectInfoOpen, setSubjectInfoOpen] = useState(false);
    const [asmtToUpdate, setAsmtToUpdate] = useState();
    const [asmtDialogOpen, setAsmtDialogOpen] = useState(false);
    // study linkage (cribsy-api docs/ENROLLMENT.md; decisions D18-D20)
    const study = useStudy();
    const [claimOpen, setClaimOpen] = useState(false);
    const [claimReason, setClaimReason] = useState('banner');
    const [claimInitialCode, setClaimInitialCode] = useState(undefined);
    const [resumeUploadAfterClaim, setResumeUploadAfterClaim] = useState(false);
    const [parentId, setParentId] = useState(null);
    const [uploadEnabled, setUploadEnabled] = useState(false);
    const [dobButtonText, setDobButtonText] = useState(t('dobbutton',{ns:'dashboard'}));
    const initialCardDescription = t('step1para',{ns:'dashboard'});
    const updatedCardDescription = t('step1alt',{ns:'dashboard'}); 
    const [dobCardDescription, setDobCardDescription] = useState(initialCardDescription);


    const loginPage = AppRoutes.SIGN_IN;

    const introCardTitle = "Introduction";
    const introCardDescription = "Cribsy will analyze your infant's movements and deliver developmental metrics.\
        All you need is a smartphone camera to capture 3 minutes of your baby in the crib.\
        This works best for infants up to 15 weeks after birth. Make sure you check the Terms of Service at the bottom of this page.\
        Click button below to learn how best to make a crib video.";
    const introButtonText = "How to make crib videos";
    const introButtonCallback = (()=>{
        showTutorialVideo();});

    const dobCardTitle =  t('step1',{ns:'dashboard'});
    // Enrollment line under the Step 1 text once a child is linked (D25): name and study ID; twins are listed
    // together while the dashboard still works with one subject (child picker is the multi-subject round).
    const enrollmentNote = (() => {
        const linked = study.enrollments ?? [];
        if (linked.length === 0) {
            return subject?.studyid ? t('enrolledone_noname', {ns:'dashboard', studyid: subject.studyid}) : undefined;
        }
        if (linked.length === 1) {
            const e = linked[0];
            return e.firstName
                ? t('enrolledone', {ns:'dashboard', name: e.firstName, studyid: e.studyid})
                : t('enrolledone_noname', {ns:'dashboard', studyid: e.studyid});
        }
        const labels = linked.map(e => `${e.firstName || t('unnamedchild',{ns:'study'})} (${e.studyid})`);
        const children = labels.slice(0, -1).join(', ') + t('listand',{ns:'dashboard'}) + labels[labels.length - 1];
        return t('enrolledmany', {ns:'dashboard', children});
    })();
    const dobButtonCallback = (()=>{
        setSubjectInfoOpen(true)});


    const videoCardTitle = t('step2',{ns:'dashboard'});
    const videoCardDescription = t('step2para',{ns:'dashboard'});
    const videoButtonText = t('uploadbutton',{ns:'dashboard'});
    const videoButtonCallback = (()=>{
        // Upload gate (D19): only when a claim is waiting for this family and this child is not linked yet.
        // The upload itself is never blocked; "Not now" goes straight on to the upload dialog.
        const subjectLinked = study.isSubjectLinked(subject?._id) || !!subject?.studyid;
        if (authLevel === 0 && study.pending && !subjectLinked) {
            setClaimReason('upload');
            setClaimInitialCode(study.pendingCode);
            setResumeUploadAfterClaim(true);
            setClaimOpen(true);
            return;
        }
        setAsmtDialogOpen(true);});
    const openClaimDialog = (reason) => {
        setClaimReason(reason);
        setClaimInitialCode(study.pendingCode);
        setResumeUploadAfterClaim(false);
        setClaimOpen(true);
    };
    const claimDialogClosed = (result) => {
        setClaimOpen(false);
        if (resumeUploadAfterClaim) {
            setResumeUploadAfterClaim(false);
            setAsmtDialogOpen(true);
        }
    };
    // A code that arrived through the letter's link opens the dialog once the account is registered (D20).
    useEffect( ()=> {
        if (study.pendingCode && authLevel >= 0 && !claimOpen) {
            openClaimDialog('link');
        }
    }, [study.pendingCode, authLevel]);

    useEffect( ()=> {
        setAuthLevel(cribsyUser?.authLevel)
    }, []);


    useEffect(()=>{
        socket.on("message", handleSocketMessage);
    },[]);

    useEffect(()=>{
        //debugLog('[Dashboard] CribsyUser:', kiwiUser);
        setAuthenticated(cribsyUser?.isAuthenticated);
        //debugLog('Subject:', subject);
        if(subject?.parentid != undefined && subject?.parentid != ''){
            debugLog('Enabling upload button');
            setUploadEnabled(true);
        }
        if (cribsyUser?.authLevel >= 5){
            debugLog('Admin user...emable upload button');
            setUploadEnabled(true); // enable upload button for admin
        }

        if(subject?.dob && subject?.duedate && subject?.parentid !== ''){
            debugLog('Subject has both DOB and DUEDATE!');
            setDobButtonText(t('dobbuttonalt',{ns:'dashboard'}));
            setDobCardDescription(updatedCardDescription);
        }
        setParentId(cribsyUser?._id);
        userRef.current = cribsyUser;
    },[cribsyUser, subject]);

    // Re-fetch the unfiltered assessment list and store it both in state and
    // the ref. Used on initial mount and on Reset Filter.
    const refreshAllAssessments = async () => {
        const asmts = await getAllAssesments(cribsyUser?.firebaseUser);
        debugLog('Asmts:', asmts?.length);
        const safeAsmts = Array.isArray(asmts) ? asmts : [];
        assessmentsRef.current = safeAsmts;
        _setAssessments(safeAsmts);
        return { count: safeAsmts.length };
    };

    useEffect (()=>{
        if (!cribsyUser) { return;}
        debugLog('Get asmts for:', cribsyUser?.firebaseUser?.uid);
        const getasmts = async ()=> {
            await refreshAllAssessments();

            const samples = await getSampleAssesments(cribsyUser?.firebaseUser);
            debugLog('Sample asmts:', samples?.length);
            if (samples){
                setSampleAssessments(samples.slice(0,2)); // use only two sample videos
            }
            //debugLog('Subject:', subject);
            if(subject?.dob && subject?.duedate && subject?.parentid !== ''){
                debugLog('Subject has both DOB and DUEDATE!');
                setDobButtonText(t('dobbuttonalt',{ns:'dashboard'}));
                setDobCardDescription(updatedCardDescription);
            }
        }
        if(cribsyUser){
            getasmts();
        }
    },[cribsyUser]);

    // Check if any assessments are being processed and update global state
    useEffect(() => {
        const processingAssessments = assessments.filter(asmt =>
            asmt.status !== 'complete' && asmt.percentageCompleted
        );

        if (processingAssessments.length > 0) {
            // Calculate average percentage if multiple videos processing
            const totalPercentage = processingAssessments.reduce((sum, asmt) =>
                sum + (asmt.percentageCompleted || 0), 0
            );
            const avgPercentage = Math.round(totalPercentage / processingAssessments.length);

            setProcessing({ isProcessing: true, percentage: avgPercentage });
        } else {
            setProcessing({ isProcessing: false, percentage: 0 });
        }
    }, [assessments, setProcessing]);

    const showTutorialVideo = () => {
        const url = (i18n.language=='en') ? 'https://youtu.be/jKOm49wJ9Aw': 
        'https://youtu.be/81fX677PoHM' ;
        window.open(url,'_blank');
       
    };

    const handleAccordion = ()=> {
        setExpanded(!expandAccordion);
        setSampleExpanded(false);
    };

    const handleSampleAccordion = ()=> {
        setSampleExpanded(!expandSampleAccordion);
        setExpanded(false);
    };

    const routeChange = (name)=>{
        debugLog('ROUTE CHANGE');
        history.push(name);
    };

    const handleDateClose = ()=> {
        setSubjectInfoOpen(false);
    }
    const handleSocketMessage = async (message)=>{
        const asmtId = message?.id;
        const status = message?.status;
        const percCompleted = message?.percentageCompleted;
        const stage = message?.stage;
        const pipeline = message?.pipeline;

        // debugLog('Message:', message);
        // update assessment variable
        let found = assessmentsRef.current.find(item => item._id==asmtId);
        if(found){
            found["percentageCompleted"] = percCompleted;
            found["status"] =  status;
            if (stage) {
                found["stage"] = stage;
            }
            if (pipeline) {
                found["pipeline"] = pipeline;
            }
            if (status == 'complete'){
                await updateAssessments();
                // the current asmt will have all the data with the metrics now
                found = assessmentsRef.current.find(item=>item._id == asmtId);
                found["status"] = 'complete';
            }
            let localAsmts = [];
            for(let i=0; i<assessmentsRef.current.length;i++){
                localAsmts.push(assessmentsRef.current[i]);
            }
            _setAssessments(localAsmts);
            // without copy to this new variable, localAsmts, any React component referring to assessments or
            // assessmentsRef.current will not re-render
            // debugLog('Modified Asmts:', localAsmts);
        }
        else {
            // refresh asmt list
            if(userRef.current?.firebaseUser){
                updateAssessments();
            }
        }

    };

    const updateAssessments = async ()=> {
        const asmts = await getAllAssesments(userRef.current?.firebaseUser);
        debugLog('Refreshed Asmts:', asmts);
        assessmentsRef.current = asmts;
        _setAssessments(asmts);
    };

    const newAsmtDialogComplete = ()=> {
        setAsmtDialogOpen(false);
        // get asmts for this user from the API
        updateAssessments();
        // perhaps show the user if the asmts are being processed?
        setExpanded(true);
    }


    const handleAssessmentsFilter = async (asmtProps) => {
        debugLog('Asmt Filter Props:', asmtProps);
        var startDate = asmtProps.startDate;
        var endDate = asmtProps.endDate;
        var includeAllDates = asmtProps.includeAllDates?.disableDates;
        var parentEmail = asmtProps.parentEmail;


        const filterArray = [];



        // dates are in number format, convert to date object
        if(startDate){
            startDate = new Date(startDate);
        }
        debugLog('Start Date:', startDate);
        if(endDate){
            endDate = new Date(endDate);
        }
        debugLog('End Date:', endDate);

        if (parentEmail != '') {
          debugLog('Parent Email:', parentEmail);
        }

        debugLog('Include All Dates?:', includeAllDates);

        if (parentEmail != '' && parentEmail != null) {

          const subject = await getSubjectFromParentEmail(cribsyUser?.firebaseUser, parentEmail);
          if (!subject || subject.length === 0) {
            // No subject for this parent → no assessments can match. Clear the displayed
            // list explicitly so the previously-shown default results don't linger.
            debugLog('No subject found for parent email:', parentEmail);
            assessmentsRef.current = [];
            _setAssessments([]);
            return { count: 0 };
          }
          debugLog('Subject with id:', subject[0]._id);
          filterArray.push( {subjectId: subject[0]._id});
        }

        if (includeAllDates){
            // just add parent email in filter
        }
        else {
            // add start end dates
            filterArray.push( {date:{'$gt': startDate}});
            filterArray.push( {date:{'$lt': endDate}});
        }

        // get filtered asmts

        var fullFilter = {}
        debugLog('filterArray:', filterArray);
        if (filterArray.length > 0) {
          fullFilter = {'$and':filterArray};
        }


        const asmts = await getFilteredAssesments(cribsyUser?.firebaseUser, parentEmail, JSON.stringify(fullFilter));
        debugLog('Asmts:', asmts);
        const safeAsmts = Array.isArray(asmts) ? asmts : [];
        assessmentsRef.current = safeAsmts;
        _setAssessments(safeAsmts);
        return { count: safeAsmts.length };
    }

    const handleRestartInference = async (asmt) => {
        debugLog('Reprocessing asmt');


        let message = t('restartmsg',{ns:'asmttablehead'});
        const confirmResult = await showDialog(t('deletetitle',{ns:'utils'}), message, t('ok',{ns:'utils'}),
        t('cancel',{ns:'utils'}));

        // now, reprocess the video

        if (confirmResult){
            // parse the resultUrl if it exists
            await restartInference(asmt, cribsyUser);
        }
        else {
        return;
        }

    }

    const handleRestartSurpriseInference = async (asmt) => {
        debugLog('Restarting surprise calculation only');

        let message = t('restartsurprisemsg',{ns:'asmttablehead'}) || 'This will skip pose inference and only recalculate the neuromotor score. Continue?';
        const confirmResult = await showDialog(t('deletetitle',{ns:'utils'}), message, t('ok',{ns:'utils'}),
        t('cancel',{ns:'utils'}));

        if (confirmResult){
            await restartInference(asmt, cribsyUser, true);
        }
        else {
        return;
        }
    }

    const handleDeleteAssessment = async (asmt) => {
        debugLog('Delete assessment:', asmt);

        const message = `Are you sure you want to delete this video and all associated data? This action cannot be undone.`;
        const confirmResult = await showDialog('Delete Video', message, 'Delete', 'Cancel');

        if (!confirmResult) {
            return;
        }

        try {
            const asmtId = asmt?._id;
            if (!asmtId) {
                debugLog('No id for asmt:', asmt);
                await showAlert('Error', 'Could not find assessment ID', 'OK');
                return;
            }

            // Delete video file from Firebase Storage if it exists
            if (asmt?.video) {
                try {
                    debugLog('Deleting video from storage:', asmt.video);
                    await firebaseStorage.refFromURL(asmt.video).delete();
                    debugLog('Video deleted from storage');
                } catch (err) {
                    debugLog('Error deleting video from storage:', err);
                    // Continue with assessment deletion even if video deletion fails
                }
            }

            // Delete result videos from Firebase Storage if they exist
            if (asmt?.resulturl) {
                try {
                    const urls = asmt.resulturl.split('|');
                    for (let i = 0; i < urls.length; i++) {
                        debugLog('Deleting result video:', urls[i]);
                        await firebaseStorage.refFromURL(urls[i]).delete();
                    }
                    debugLog('Result videos deleted from storage');
                } catch (err) {
                    debugLog('Error deleting result videos:', err);
                }
            }

            // Delete assessment from database
            debugLog('Deleting assessment from database:', asmtId);
            const response = await fetch(`${process.env.REACT_APP_CPAP_API}assessments/${asmtId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${cribsyUser?.firebaseUser?.bearerToken}`,
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error('Failed to delete assessment from database');
            }

            debugLog('Assessment deleted from database');

            // Update local state - remove from assessments list
            const updatedAssessments = assessmentsRef.current.filter(item => item._id !== asmtId);
            assessmentsRef.current = updatedAssessments;
            _setAssessments(updatedAssessments);

            await showAlert('Success', 'Video and all associated data have been deleted', 'OK');
        } catch (error) {
            console.error('Error deleting assessment:', error);
            await showAlert('Error', `Failed to delete assessment: ${error.message}`, 'OK');
        }
    }
    
    async function  restartInference(asmt, user, skipPoseInference = false) {
      const resultUrl = asmt?.resulturl;
      let asmtId = asmt?._id;
      if (!asmtId) {
        debugLog('No id for asmt:', asmt);
        return;
      }

      debugLog('Result url:', resultUrl);

      try{
        let urls = resultUrl.split('|'); // split the resultUrl by the pipe character
        debugLog('Result Urls:', urls);
        // delete the existing derived data for this video, including pose overlay video
        for (let i = 0; i < urls.length; i++) {
            debugLog('Url:', urls[i]);
            // delete the resultUrl from the cloud
            try {
            //deleteCloudVideo(urls[i]);
            let videoUrl = urls[i];
            debugLog('deleteCloudVideo:', videoUrl);
            
            const storageRef = await firebaseStorage.refFromURL(videoUrl).delete().then( ()=> {
                debugLog('Cloud Video file deleted');
            }).catch ((error) => {
                debugLog('Error deleting cloud file:');
            });
            }
            catch (err) {
            debugLog('Error deleting: ', err);
            }
        }
        } catch (err){
            debugLog('Error obtaining previous urls:', err);
        }

      // prepare the assessment entry in the assessmentinfo table to receive percentage completed updates
      // via socket 
    debugLog('Setting up asmt for updates:', asmtId);

    let found = assessmentsRef.current.find(item => item._id==asmtId);
    debugLog('Found asmt:', found);
    let foundSample = false;
    if(!found){
        // try sample asmts
        found = sampleAssessmentsRef.current.find(item => item._id==asmtId);
        foundSample = true;
    }
    if (foundSample) {debugLog('Found sample asmt')}
    if(found){
        found["percentageCompleted"] = 0;
        found["status"] =  '';
        found['resulturl'] = ''; // clear the result url as inference will be restarted
        let localAsmts = [];
        if(!foundSample) {
            for(let i=0; i<assessmentsRef.current.length;i++){
                localAsmts.push(assessmentsRef.current[i]);
            }
            _setAssessments(localAsmts);
            debugLog('Local asmts:', localAsmts);
        }
        else{
            for(let i=0; i<sampleAssessmentsRef.current.length;i++){
                localAsmts.push(sampleAssessmentsRef.current[i]);
            }  
            setSampleAssessments(localAsmts); 
        }
        // without copy to this new variable, localAsmts, any React component referring to assessments or
        // assessmentsRef.current will not re-render
    }

      debugLog('Restarting inference for:', asmt?._id, 'skipPoseInference:', skipPoseInference);
      await refreshToken(user);
      const result = reprocessVideo(user, asmt?._id, skipPoseInference);
    }


    
    {
        return (
            <div>
                <SocketIOContext.Provider value={{socket}}>
                <div className={classes.paper}>
                <Grid container 
                    style={{'min-width':'345px'}}
                    spacing={4}
                >
                    

                <Grid item xs={12}>
                    <Typography
                        display="inline"
                        ml={2}
                        color="warning"
                        variant="body2"
                    >
                    </Typography>
                    <Card mb={6}>
                    <CardContent>

                  
                    {!isAuthenticated && 
                        <Typography 
                        display='inline'
                        ml={2}
                        color="secondary"
                        variant='h5'>
                            Welcome to Cribsy. 
                            {!isAuthenticated &&
                            <div>
                            <Button color="primary"
                                
                                onClick={()=>{routeChange(AppRoutes.SIGN_IN)}}
                                >
                                Sign in
                            </Button>
                                <Typography display='inline'>
                                to proceed.
                                </Typography>
                            </div> 
                            }
                        </Typography>
                    }
                    <Grid container xs>
                        <Typography
                            display="inline"
                            ml={2}
                            color="secondary"
                            variant="h6"
                        >
                            {t('chatbottitle', {ns:"dashboard"})}!
                        </Typography>
                    </Grid>
                    <Grid container xs>
                        <Typography
                            display="inline"
                            ml={2}
                            variant="body2"
                        >
                            {t('chatbotpara',{ns:'dashboard'})}.
                            {/* Today is {new Date(currentDate).toDateString()} */}
                        </Typography>
                    </Grid>
                    </CardContent>
                    </Card>
                </Grid>


                
                <Grid item xs={12}>
                    <Typography
                        display="inline"
                        ml={2}
                        color="warning"
                        variant="body2"
                    >
                    </Typography>
                    
                    <Card mb={6}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                        {t('intro',{ns:'dashboard'})}
                        </Typography>
                        <Typography variant="body2" gutterBottom my={2}>
                        {t('intropara',{ns:'dashboard'})}
                        </Typography>
                        <Button variant="outlined" color="primary" onClick={()=>{showTutorialVideo();}}>
                            {t('howtobutton',{ns:'dashboard'})}
                        </Button>
                    </CardContent>
                    </Card>
                </Grid>
                    

                    {authLevel === 0 && study.loaded && study.pending && study.enrollments.length === 0 && (
                    <Grid item xs={12}>
                        {/* pending enrollment claim (D19): shown at every login until the child is linked */}
                        <Alert severity="info"
                            action={<Button color="inherit" size="small" onClick={()=>openClaimDialog('banner')}>{t('bannerbutton',{ns:'study'})}</Button>}>
                            {t('bannertext',{ns:'study'})}
                        </Alert>
                    </Grid>
                    )}

                    <Grid item xs={12} sm={6} style={{display: 'flex'}}>
                        {/* <Typography
                            display="inline"
                            ml={2}
                            color="warning"
                            variant="body2"
                        >
                        </Typography> */}
                        <Actions backgroundImage="/images/rsz_baby1.jpeg"
                            authenticated={isAuthenticated}
                            title={dobCardTitle} description={dobCardDescription} note={enrollmentNote}
                            buttonText={dobButtonText} buttonCallback={dobButtonCallback}/>
                    </Grid>


                    <Grid item xs={12} sm={6} style={{display: 'flex'}}>
                        {/* <Typography
                            display="inline"
                            ml={2}
                            color="warning"
                            variant="body2"
                        >
                        </Typography> */}
                        <Actions backgroundImage="/images/rsz_3baby-in-a-basket.jpeg"
                            authenticated={isAuthenticated && uploadEnabled}
                            title={videoCardTitle} description={videoCardDescription}
                            buttonText={videoButtonText} buttonCallback={videoButtonCallback}/>
                    </Grid>
                    
                    <Grid item md={12} sm={12} xs={12} >
                        
                        <div>
                        { assessments &&                
                            <Accordion expanded={expandAccordion} >
                                <AccordionSummary
                                    aria-controls="panel1a-content"
                                    expandIcon={<ExpandMoreIcon color="primary"/>}
                                    IconButtonProps={{
                                        onClick:handleAccordion
                                    }}
                                    id="update-assessment-header"
                                >
                                    <Typography
                                        display="inline"
                                        ml={2}
                                        color="secondary"
                                        variant="h6"
                                    >
                                        {t('videos',{ns:'dashboard'})}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container>
                                    <Grid item md={12} sm={12} xs={12}>
                                    <AssessmentInfoTable
                                        allAssessments={assessmentsRef.current}
                                        handleFilter = {handleAssessmentsFilter}
                                        handleResetFilter = {refreshAllAssessments}
                                        handleRestart = {handleRestartInference}
                                        handleRestartSurprise = {handleRestartSurpriseInference}
                                        handleDelete = {handleDeleteAssessment}
                                        />
                                    </Grid>

                                    <Grid item md={12} sm={12} xs={12}>
                                        <Typography variant="caption">
                                            {t('videosmsg',{ns:'dashboard'})}
                                        </Typography>
                                    </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        }
                        </div>
                    </Grid>

                    <Grid item md={12} sm={12} xs={12} >
                        
                        <div>
                        { assessments &&                
                            <Accordion expanded={expandSampleAccordion}>
                                <AccordionSummary
                                    aria-controls="panel1a-content"
                                    expandIcon={<ExpandMoreIcon color="primary"/>}
                                    IconButtonProps={{
                                        onClick:handleSampleAccordion
                                    }}
                                    id="update-assessment-header"
                                >
                                    <Typography
                                        display="inline"
                                        ml={2}
                                        color="secondary"
                                        variant="h6"
                                    >
                                        {t('samplevids',{ns:'dashboard'})}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container>
                                    <Grid item md={12} sm={12} xs={12}>
                                    <AssessmentInfoTable
                                        allAssessments={sampleAssessments}
                                        handleFilter = {handleAssessmentsFilter}
                                        handleResetFilter = {refreshAllAssessments}
                                        handleRestart = {handleRestartInference}
                                        handleRestartSurprise = {handleRestartSurpriseInference}
                                        handleDelete = {handleDeleteAssessment}
                                        />
                                    </Grid>

                                    <Grid item md={12} sm={12} xs={12}>
                                        <Typography variant="caption">
                                            {t('samplevidmsg',{ns:'dashboard'})}.
                                            
                                        </Typography>
                                    </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        }
                        </div>
                    </Grid>

                </Grid>
                </div>


                <SubjectInfo isOpen={subjectInfoOpen} handleClose={handleDateClose} parentId={cribsyUser._id}/>
                <StudyClaimDialog open={claimOpen} reason={claimReason} initialCode={claimInitialCode} onClose={claimDialogClosed} />
                <NewAssessmentDialog
                    asmtToEdit = {asmtToUpdate}
                    isOpen = {asmtDialogOpen}
                    parentId = {parentId}
                    dialogComplete = {newAsmtDialogComplete}
                    subject = {subject}
                />
                </SocketIOContext.Provider>
            </div>
          );
    }
}

export default Dashboard;